/**
 * Two-letter initials of a workspace name, for the workspace mark (design: workspaces a1):
 * "Lind Management" → "LM", "Nightshift" → "NI".
 */
export function workspaceInitials(name: string): string {
  const words = name
    .trim()
    .split(/\s+/)
    .filter((word) => word !== '');
  const [first, second] = words;
  if (first !== undefined && second !== undefined) {
    return `${first.charAt(0)}${second.charAt(0)}`.toUpperCase();
  }
  return (first ?? '').slice(0, 2).toUpperCase();
}
